module.exports = __webpack_public_path__ + "img/s3place.dcd81b02.png";